import { Reveal, MaskLines } from "./Reveal";
import { Photo } from "./Photo";
import { IMAGES } from "@/constants/images";

export const Lifestyle = () => (
  <section id="life" className="relative border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <Reveal>
            <span className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
              Chapter 02 &mdash; The Life
            </span>
          </Reveal>
          <h2 className="mt-8 max-w-3xl font-['Playfair_Display'] text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
            <MaskLines whileInView lineClass="gold-metallic-text" lines={["The market already pays you.", "It should pay for a better life too."]} />
          </h2>
        </div>
        <Reveal delay={0.2} className="max-w-sm">
          <p className="text-sm leading-relaxed text-[#a1a1aa]">
            Shabz doesn't just teach the charts &mdash; she lives the outcome. The travel, the
            freedom, the calm of trading with real conviction. That is the standard a
            6 figure stock trading coach should hold you to.
          </p>
        </Reveal>
      </div>

      {/* Asymmetric bento — real photos of Shabz */}
      <div className="mt-16 grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-12 lg:grid-rows-2">
        <Reveal className="lg:col-span-7 lg:row-span-2">
          <div className="corner-frame group relative h-full overflow-hidden">
            <Photo
              testid="life-photo-1"
              src={IMAGES.lifestyle1}
              alt="Shabz Fazl living the lifestyle her trading pays for"
              className="aspect-[4/5] w-full transition-transform duration-[900ms] group-hover:scale-[1.04] sm:aspect-[3/4] lg:aspect-auto lg:h-full"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0a0a0b]/75 via-transparent to-transparent" />
            <div className="absolute bottom-7 left-7 right-7">
              <p className="font-['Playfair_Display'] text-2xl leading-tight text-[#f5f5f0] sm:text-3xl">
                Live what you trade for.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="group relative h-full overflow-hidden">
            <Photo
              testid="life-photo-2"
              src={IMAGES.lifestyle2}
              alt="Shabz Fazl, elite stock trading coach"
              className="aspect-square w-full transition-transform duration-[900ms] group-hover:scale-[1.04] lg:aspect-auto lg:h-full"
            />
          </div>
        </Reveal>

        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="gold-trim flex h-full flex-col justify-center gap-4 p-9">
            <p className="font-['Playfair_Display'] text-4xl gold-metallic-text sm:text-5xl">
              A 7-Figure Standard
            </p>
            <p className="text-sm leading-relaxed text-[#a1a1aa]">
              The traders Shabz mentors stop chasing the market for validation. They trade from a
              place of surplus &mdash; and it quietly changes everything downstream: the size, the
              sleep, the freedom.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
